import React, { ReactNode, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import { useGetStatusQuery } from "components/Slices/usersApiSlice";
import { BannedHome } from "screens/Banned/BannedHome";

import { MoneyLoading } from "./MoneyLoading";

export const PrivateRouter = ({ children }: { children: ReactNode }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  //check if user banned from useGetStatusQuery
  const { data: status, isLoading } = useGetStatusQuery();

  // Only block on the FIRST status fetch. When the query errors, children
  // re-subscribing to it trigger a refetch, and isLoading goes true again
  // (RTK: isLoading = isFetching && no data). Unmounting the tree here then
  // causes remount -> re-subscribe -> refetch, a self-sustaining request
  // storm against a failing /users/status (BUG-002).
  const hasSettled = useRef(false);
  if (!isLoading) hasSettled.current = true;

  if (isLoading && !hasSettled.current) return <MoneyLoading />;
  if (status?.userStatus === "banned" && user) return <BannedHome />;

  return user ? (
    <div
      style={{
        backgroundImage: "url('/leaves.png')",
        backgroundColor: "#f7faf7",
        backgroundBlendMode: "lighten",
        maxWidth: "100%",
        padding: 0,
        minHeight: "100vh",
      }}
    >
      {children}
    </div>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRouter;
